import { render, staticRenderFns } from "./ListOfSettings.vue?vue&type=template&id=99ecf146&"
import script from "./ListOfSettings.vue?vue&type=script&lang=js&"
export * from "./ListOfSettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports